function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.94509 4.8H24.0407V0H4.80814C2.15298 0 0 2.14933 0 4.8V20.4C0 22.388 1.61473 24 3.6061 24H6.6753C8.51241 24 10.2286 23.0833 11.2477 21.5573L15.5517 15.1127C15.8488 14.6673 16.349 14.4 16.8852 14.4H18.1647C18.7551 14.4 19.2332 14.8773 19.2332 15.4667V24H24.0414V14.4C24.0414 11.7493 21.8884 9.6 19.2332 9.6H15.7807C14.1827 9.6 12.6908 10.3973 11.804 11.7247L7.52073 18.1387C6.70802 19.3553 4.80814 18.7813 4.80814 17.3187V6.93333C4.80814 5.75533 5.76509 4.8 6.94509 4.8Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.0814 0H28.8489V4.8H46.4787C47.3636 4.8 48.0814 5.51667 48.0814 6.4V8C48.0814 8.88333 47.3636 9.6 46.4787 9.6H33.657C31.0019 9.6 28.8489 11.7493 28.8489 14.4V24H33.657V16.5333C33.657 15.3553 34.614 14.4 35.794 14.4H48.0814C50.7366 14.4 52.8896 12.2507 52.8896 9.6V4.8C52.8896 2.14933 50.7366 0 48.0814 0Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.5363 4.8V0H61.3037C58.6486 0 56.4956 2.14933 56.4956 4.8V19.2C56.4956 21.8507 58.6486 24 61.3037 24H80.5363V19.2H63.4407C62.2607 19.2 61.3037 18.2447 61.3037 17.0667V6.93333C61.3037 5.75533 62.2607 4.8 63.4407 4.8H80.5363Z",
  fill: "currentColor"
});

var SvgLogoGpcNew = function SvgLogoGpcNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 81,
    height: 24,
    viewBox: "0 0 81 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoGpcNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-gpc-new.3fc3c719.svg";
export { ForwardRef as ReactComponent };